/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type FreshdeskData = {
  tickets: boolean;
  articles: boolean;
};

/** @internal */
export const FreshdeskData$inboundSchema: z.ZodType<
  FreshdeskData,
  z.ZodTypeDef,
  unknown
> = z.object({
  tickets: z.boolean(),
  articles: z.boolean(),
});
/** @internal */
export type FreshdeskData$Outbound = {
  tickets: boolean;
  articles: boolean;
};

/** @internal */
export const FreshdeskData$outboundSchema: z.ZodType<
  FreshdeskData$Outbound,
  z.ZodTypeDef,
  FreshdeskData
> = z.object({
  tickets: z.boolean(),
  articles: z.boolean(),
});

export function freshdeskDataToJSON(freshdeskData: FreshdeskData): string {
  return JSON.stringify(FreshdeskData$outboundSchema.parse(freshdeskData));
}
export function freshdeskDataFromJSON(
  jsonString: string,
): SafeParseResult<FreshdeskData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => FreshdeskData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'FreshdeskData' from JSON`,
  );
}
